import {
  Avatar,
  Chip,
  Grid,
  Select,
  SelectChangeEvent,
  styled,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MDBox from "../../../Components/MDBox";
import MDButton from "../../../Components/MDButton";
import MDTypography from "../../../Components/MDTypography";
import { symboledParamsAction } from "../../../Context/redux/actions";
import FieldDto from "../../../Types/Api/DTO/FieldDto";
import { FieldRange } from "../../../Types/Api/DTO/FieldRangeDto";
import { ErrorToaast } from "../../../utils/toast/Toast";
const alphabet = [
  "A",
  "B",
  "C",
  "D",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];
export default function SecondStep(props: {
  disabled: boolean;
  status: boolean;
  handleBack: any;
  handleNext: any;
}) {
  let selectedParams: FieldDto[] = useSelector(
    (state: any) => state.selectedParams
  );
  let symboledParams: FieldRange[] = useSelector(
    (state: any) => state.symboledParams
  );
  const dispatch = useDispatch();
  const [, setCounter] = useState<number>(0);
  const handleSelectSymbole = (
    e: SelectChangeEvent<string>,
    model: FieldDto
  ) => {
    let value = e.target.value;

    symboledParams.map((t) => {
      if (t.Field.id === model.id) {
        if (value === "none") {
          t.Symbole = "@";
        } else {
          t.Symbole = value;
        }
      }
      return t;
    });
    setCounter((c) => c + 1);
    return dispatch(symboledParamsAction(symboledParams));
  };
  const hanldeNext = async () => {
    if (symboledParams.filter((x) => x.Symbole !== "@").length < 1) {
      return ErrorToaast("حداقل یک پارامتر باید نشان گذاری شود");
    }
    props.handleNext();
  };
  useEffect(() => {
    let symboleForParams: FieldRange[] = [];
    if (symboledParams.length < 1) {
      selectedParams.forEach((r) => {
        symboleForParams.push({ Field: r, Symbole: "@" });
      });
      dispatch(symboledParamsAction(symboleForParams)); // dispatch(symboledParamsAction());
    }
  }, []);

  return (
    <MDBox px={2}>
      <MDBox>
        <MDBox bgColor={"#f0f2f5"} borderRadius={5} p={"10px 5px"} mb={5}>
          <MDTypography fontSize={14}>
            لطفا برای هر پارامتر یک نماد انتخاب کنید . نماد مورد نظر در مرحله
            فرمول نویسی استفاده میشود . اگر پارامتری در فرمول استفاده نشد آن را
            خالی بگذارید.
          </MDTypography>
        </MDBox>

        <Grid container spacing={3}>
          {selectedParams.map((item) => {
            return (
              <Grid
                key={item.key}
                container
                justifyContent={"space-between"}
                item
                xs={12}
                md={6}
                lg={6}
              >
                <Grid item xs={2} md={2} lg={2} alignSelf={"center"}>
                  <MDTypography fontSize={14} fontWeight={"bold"}>
                    {item.name}
                  </MDTypography>
                </Grid>
                <Grid item xs={10} md={10} lg={10}>
                  <Select
                    name={"asd"}
                    onChange={(e) => handleSelectSymbole(e, item)}
                    native
                    defaultValue={symboledParams
                      .filter((p) => p.Field.key === item.key)[0]
                      ?.Symbole.replace("@", "")}
                    id="grouped-native-select"
                    fullWidth
                  >
                    <option value={"none"}>بدون انتخاب</option>
                    {alphabet.map((r: string) => {
                      let disabled =
                        symboledParams.filter((d) => {
                          return d.Symbole === r;
                        }).length > 0;
                      return (
                        <option
                          disabled={disabled}
                          style={{ background: !disabled ? "none" : "#f0f2f5" }}
                          key={r}
                          value={r}
                        >
                          {r}
                        </option>
                      );
                    })}
                  </Select>
                </Grid>
              </Grid>
            );
          })}
        </Grid>
      </MDBox>
      <MDBox sx={{ display: "flex", flexDirection: "row", py: 2 }}>
        <MDButton
          color="primary"
          variant={"outlined"}
          disabled={props.disabled}
          onClick={props.handleBack}
          sx={{ mr: 1 }}
        >
          مرحله قبل
        </MDButton>
        <MDBox sx={{ flex: "1 1 auto" }} />

        <MDButton onClick={hanldeNext} variant={"outlined"} color="info">
          {props.status ? "اتمام" : "مرحله بعد"}
        </MDButton>
      </MDBox>
    </MDBox>
  );
}
